import React from "react";
import type { SidebarMenuItem } from "../types";
import { SidebarNavItem } from "./SidebarNavItem";

interface SidebarNavGroupProps {
  items: SidebarMenuItem[];
  title?: string;
  className?: string;
}

export function SidebarNavGroup({ items, title, className = "" }: SidebarNavGroupProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={`w-full ${className}`.trim()}>
      {title && (
        <div className="px-5 pb-1 pt-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          {title}
        </div>
      )}
      {items.map((item) => (
        <SidebarNavItem key={item.name} item={item} />
      ))}
    </div>
  );
}

